(function() {
	// globals
	PM.Colors = {};

	// Holds the cached color stops from the server
	PM.Colors.colorStops = [];

	// app functions

	PM.Colors.renderColors = function() {
		$.when(
			$.get('/api/plan/colors'),
			ejs.preloadTemplate('/app/config/colors/templates/colors.ejs')
		).done(function(colorsResult) {
			var stops = colorsResult[0];
			var contentHtml = ejs.rr('/app/config/colors/templates/colors.ejs', { stops: stops });
			PM.Config.renderSection('colors', contentHtml);
		});
	};

	// events

	// ─── Save colors ───────────────────────────────────────────────────────

	$(document).on('click', '.js-config-save', function() {
		var colors = [];
		var valid = true;

		$('.js-config-stop-row').each(function() {
			var percent = parseInt($(this).find('.js-config-percent').val(), 10);
			var color = $(this).find('.js-config-color').val().trim();

			if (isNaN(percent) || percent < 0 || percent > 999) {
				new Notify({ status: 'error', text: i18next.t('Percent must be between 0 and 999.'), timeout: 3000 });
				valid = false;
				return false;
			}

			colors.push({ percent: percent, color: color });
		});

		if (!valid) return;

		if (colors.length === 0) {
			new Notify({ status: 'error', text: i18next.t('Add at least one color stop.'), timeout: 3000 });
			return;
		}

		$.ajax({
			url: '/api/plan/colors',
			method: 'PUT',
			contentType: 'application/json',
			data: JSON.stringify({ colors: colors })
		}).done(function(response) {
			PM.Colors.colorStops = response.colors;
			PM.Colors.renderColors();
			new Notify({ status: 'success', text: i18next.t('Colors saved.'), timeout: 3000 });
		});
	});

	// ─── Add color stop row ─────────────────────────────────────────────────

	$(document).on('click', '.js-config-add-stop', function() {
		var $tbody = $('.js-config-stops-tbody');

		// Remove the empty placeholder row if present
		$tbody.find('tr td[colspan]').closest('tr').remove();

		var html = ejs.rr('/app/config/colors/templates/colors.ejs', {
			stops: null,
			newRow: true
		});
		var $row = $(html).find('.js-config-stop-row');
		$tbody.append($row);
	});

	// ─── Remove color stop row ──────────────────────────────────────────────

	$(document).on('click', '.js-config-remove-stop', function() {
		$(this).closest('.js-config-stop-row').remove();
	});

	// app startup

	page('/config/colors', PM.Shell.routeWithPermission('view_colors', PM.Colors.renderColors));
})();
